// トップページの固定ヘッダー（l-header--fixed）
// 160px 以上スクロールしたら is-visible を付けてフェードインさせる。

const THRESHOLD = 160;

export function setupGnavSolid() {
  const targets = [...document.querySelectorAll('[data-mp-gnav-solid]')];
  if (targets.length === 0) return;

  let ticking = false;
  const update = () => {
    const show = window.scrollY > THRESHOLD;
    targets.forEach((el) => el.classList.toggle('is-visible', show));
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true },
  );
  update();
}
